/**
 * @module geo
 */


import {ExtentA, ExtentOptions} from './types/extent.js';

/**
 * type handling extent,
 * The minimum and maximum X- and Y- coordinates of a bounding box.
 */
export class Extent extends ExtentA {
  /**
   * 	Bottom-left X-coordinate of an extent envelope.
   */
  minX: number;
  /**
   * Top-right X-coordinate of an extent envelope.
   */
  maxX: number;
  /**
   * Bottom-left Y-coordinate of an extent envelope.
   */
  minY: number;
  /**
   * Top-right Y-coordinate of an extent envelope.
   */
  maxY: number;
  /**
   * crs(( in epsg code )
   */
  crs: number;

  constructor(options: ExtentOptions|number[], crs?: any) {
    super();
    if (Array.isArray(options)) {
      this.minX = options[0];
      this.maxX = options[2];
      this.minY = options[1];
      this.maxY = options[3];
      this.crs = crs;
    } else {
      this.minX = options.minX;
      this.maxX = options.maxX;
      this.minY = options.minY;
      this.maxY = options.maxY;
      this.crs = options.crs;
    }
  }
}
